module.exports = __webpack_public_path__ + "img/09.0ca936b8.jpg";